import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/tg1'
  },
  {
    path: '/tg1',
    component: () => import('@/views/tg/tg1')
  },
  {
    path: '/tg2',
    component: () => import('@/views/tg/tg2')
  },
  {
    path: '/tg3',
    component: () => import('@/views/tg/tg3')
  },
  {
    name: 'tg4',
    path: '/tg4',
    component: () => import('@/views/tg/tg4')
  },
  {
    path: '/tg5',
    component: () => import('@/views/tg/tg5')
  },
  {
    path: '/tg6',
    component: () => import('@/views/tg/tg6')
  },
  {
    path: '/tg7',
    component: () => import('@/views/tg/tg6')
  },
  {
    path: '/publicity1',
    component: () => import('@/views/publicity1')
  },
  {
    path: '/interview',
    component: () => import('@/views/interview')
  },
  {
    path: '/job-exam/:orign',
    component: () => import('@/views/job-exam')
  },
  {
    path: '/jxb',
    component: () => import('@/views/jxb')
  },
  {
    name: 'erjian',
    path: '/erjian/:id?',
    component: () => import('@/views/erjian')
  },
  {
    name: 'ky',
    path: '/ky/:id?',
    component: () => import('@/views/ky')
  },
  {
    name: 'ky-bhx',
    path: '/ky-bhx/:id/:promotednum',
    component: () => import('@/views/ky-bhx')
  },
  {
    name: 'tb',
    path: '/tb/:id',
    component: () => import('@/views/tb')
  },
  {
    name: 'hs',
    path: '/hs/:id',
    component: () => import('@/views/hs')
  },
  {
    name: 'hs-tb',
    path: '/hs-tb/:id',
    component: () => import('@/views/hs-tb')
  },
  {
    name: 'bhx',
    path: '/bhx/:id/:promotednum',
    component: () => import('@/views/bhx')
  },
  {
    name: 'aqs',
    path: '/aqs',
    component: () => import('@/views/aqs')
  },
  {
    name: 'aqsjf',
    path: '/aqsjf/:id',
    component: () => import('@/views/aqsjf')
  },
  {
    path: '/hs-ky/:id/:channelId?',
    component: () => import('@/views/hs-ky')
  },
  {
    path: '/hs-zk/:id/:channelId?',
    component: () => import('@/views/hs-zk')
  },
  {
    path: '/hs-xm/:name',
    component: () => import('@/views/hs-xm')
  },
  {
    path: '/sanwei/:name/:promotednum?',
    component: () => import('@/views/sanwei')
  },
  {
    path: '/sanwei-ky',
    component: () => import('@/views/sanwei-ky')
  },
  {
    path: '/jfxx-xm/:name',
    component: () => import('@/views/jfxx-xm')
  },
  {
    path: '/bhx-xm/:name/:promotednum',
    component: () => import('@/views/bhx-xm')
  },
  {
    path: '/aqs-zb',
    component: () => import('@/views/aqs-zb')
  },
  {
    path: '/zk-tb/:name',
    component: () => import('@/views/zk-tb')
  },
  {
    path: '/xw-tg/:name',
    component: () => import('@/views/xw-tg')
  },
  {
    path: '/points-exchange',
    component: () => import('@/views/points-exchange')
  },
  {
    path: '/pull-new/:id',
    component: () => import('@/views/pull-new')
  },
  {
    path: '/zmt/:name',
    component: () => import('@/views/zmt')
  },
  {
    path: '/pintuan',
    component: () => import('@/views/pintuan/index')
  },
  {
    path: '/zkwh/:name',
    component: () => import('@/views/zkwh/index')
  },
  {
    path: '/sxts/:name',
    component: () => import('@/views/sxts/index')
  },
  {
    path: '/sxts-jzs2',
    component: () => import('@/views/sxts-jzs2/index')
  },
  {
    path: '/bsbts/:name',
    component: () => import('@/views/bsbts/index')
  },
  {
    path: '/syts/:name/:promotednum?',
    component: () => import('@/views/syts/index')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/zk-tg',
  routes
})

export default router
